export const Admin = () => {
    return (
      <div>
        <p>あなたは管理者です</p>
        <h1>管理者専用メニュー</h1>
        <p>参考にしたサイト</p>
        <a href="https://qiita.com/ayato_k/items/bed84dbdee79c68bd55a"><h3>ログインの保持方法</h3></a>
        <a href="https://qiita.com/akifumii/items/c302fdc633d8eba2af0a"><h3>JSX内にIFを入れる方法</h3></a>
        
      </div>
    );
  };
  